import { render, staticRenderFns } from "./IframeModalV3.vue?vue&type=template&id=66ece500"
import script from "./IframeModalV3.vue?vue&type=script&lang=ts"
export * from "./IframeModalV3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports